module.exports = __webpack_public_path__ + "img/case2.84df0500.png";